import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'
import MdExpandMore from 'react-icons/lib/md/expand-more'

const styles = (theme) => ({
  root: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  expansionPanelSummary: {
    background: theme.palette.background.light,
    border: `1px solid ${theme.palette.borders.cloudier}`,
  },
  expansionPanelSummaryHeading: {
    flexBasis: '100%',
    flexShrink: 0,
    color: theme.palette.text.light,
  },
  expansionPanelText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8em',
    },
  },
  expandIcon: {
    color: theme.palette.text.light,
  },
})

class PageDescription extends React.Component {
  state = { expanded: false }

  toggleExpand = () => this.setState({ expanded: !this.state.expanded })

  render() {
    const { state } = this
    const { classes, pageDescription } = this.props
    return (
      <div className={classes.root}>
        <ExpansionPanel
          style={{ boxShadow: '0px 0px 1px #e3f3ff' }}
          expanded={state.expanded}
          onChange={this.toggleExpand}
        >
          <ExpansionPanelSummary
            classes={{ root: classes.expansionPanelSummary }}
            expandIcon={
              !state.expanded && <MdExpandMore className={classes.expandIcon} />
            }
          >
            <div className={classes.expansionPanelSummaryHeading}>
              {!state.expanded && (
                <Typography className={classes.expansionPanelText}>
                  The page description has been collapsed. Click here to see the
                  page description
                </Typography>
              )}
              {state.expanded && (
                <Typography
                  className={classes.expansionPanelText}
                  dangerouslySetInnerHTML={{ __html: pageDescription }}
                />
              )}
            </div>
          </ExpansionPanelSummary>
        </ExpansionPanel>
      </div>
    )
  }
}

PageDescription.propTypes = {
  classes: PropTypes.object.isRequired,
  pageDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default withStyles(styles)(PageDescription)



// WEBPACK FOOTER //
// ./src/components/supplements/PageDescription.js